



























import Vue from 'vue';
import { Loading } from '@descomplica/vue-components';
import Modal from './Modal.vue';
import SearchCard, { CardInfo } from '../SearchCard/SearchCard.vue';
import { Course } from '@/store/modules/course/state';
import SentryClient from '@/helpers/sentry';

interface Data {
  isLoadingCourses: boolean;
  isSubmitting: boolean;
}

export default Vue.extend({
  components: { Modal, SearchCard, Loading },
  data(): Data {
    return {
      isLoadingCourses: true,
      isSubmitting: false,
    };
  },
  computed: {
    currentCourseId(): number | undefined {
      return this.$store.getters.course?.id;
    },
    isLoading(): boolean {
      return this.isLoadingCourses || this.isSubmitting;
    },
    items(): CardInfo[] {
      const courses = this.$store.getters.availableCourses;

      return courses.map((course: Course) => ({
        key: course.id,
        content: {
          title: course.name,
          data: [
            {
              text: this.$t(`courseType.${course.type?.toLowerCase()}`),
              icon: 'secretary',
              description: `${course.duration?.toLowerCase()}`,
              iconDescription: 'timer',
            },
          ],
        },
      }));
    },
  },
  async mounted(): Promise<void> {
    try {
      await this.$store.dispatch('PULL_AVAILABLE_COURSES');
    } catch (error) {
      this.$emit('error', 'changeCourseError.couldntLoadCourses');
      SentryClient.captureError(error as any);
      this.closeModal();
    } finally {
      this.isLoadingCourses = false;
    }
  },
  methods: {
    async selectCourse(selectedItem: CardInfo): Promise<void> {
      const courseId = selectedItem.key;

      this.isSubmitting = true;

      try {
        await this.$store.dispatch('UPSERT_ADMISSION', {
          courseId,
        });
      } catch (error) {
        this.$emit('error', 'changeCourseError.couldntChangeCourse');
        SentryClient.captureError(error as any);
      } finally {
        this.closeModal();
        this.isSubmitting = false;
      }
    },
    closeModal(): void {
      this.$emit('closeModal');
    },
  },
});
